// Per-fund signal fields shared by the FundSignalPanel configs' stats cells
// and the fund explainers (gold's yield-collapse gate, GGE's CL print legs).
import type { GoldSignalResponse, GgeSignalResponse } from '../../api/client'
import type { FundSignalPayloadLike } from './fundSignalPanel'

const GATE_REASON_TEXT: Record<string, string> = {
  open_yield_ok: 'no yield collapse over the window — gate open',
  closed_yield_collapse: '10y yields collapsed beyond the drop trigger — gate closed, BUY blocked',
  gate_off: 'gate mode is off — never blocks',
  gate_open_fail_open_no_yields: 'yields data unavailable — gate fails OPEN (degraded, mirrors the C# engine convention)',
  decision_degraded: 'decision degraded (stale GC print) — gate not evaluated',
}

export interface GoldGateFields {
  dyBps: number | null
  dropBps: number | null
  gateOpen: boolean | null
  gateMode: string | null
  gateReasonText: string | null
}

/** Gold: Δy20 and the yield-collapse gate. */
export function goldGateFields(s: FundSignalPayloadLike | null): GoldGateFields {
  const g = s as GoldSignalResponse | null
  const r = g?.gate_reason
  return {
    dyBps: g?.dy20_bps ?? null,
    dropBps: g?.params_echo?.yield_collapse_drop_bps ?? null,
    gateOpen: g?.gate_open ?? null,
    gateMode: g?.params_echo?.yield_collapse_gate_mode ?? g?.gate_mode ?? null,
    gateReasonText: r ? (GATE_REASON_TEXT[r] ?? r) : null,
  }
}

export function gateStateText(open: boolean | null | undefined): string {
  return open === null || open === undefined ? '—' : (open ? 'OPEN' : 'BLOCKED')
}

/** GGE: the CL decision print + its 16:00-NY anchor — the two legs of m_0840. */
export function ggeClPrint(s: FundSignalPayloadLike | null):
  { price: number; ts: string | null; anchor: number | null; anchorTs: string | null } | null {
  const g = s as GgeSignalResponse | null
  if (!g || g.decision_price == null) return null
  return {
    price: g.decision_price,
    ts: g.decision_price_ts_utc ?? null,
    anchor: g.anchor_price ?? null,
    anchorTs: g.anchor_price_ts_utc ?? null,
  }
}
